module.exports = __webpack_public_path__ + "img/prescription-charge-document.b712ff33.svg";